import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src"]




export default /*@__PURE__*/_defineComponent({
  __name: 'Logotype',
  props: {
    logo: {},
    xl: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (props.logo !== '')
    ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: props.logo,
        class: _normalizeClass([props.xl ? 'h-[80px]' : 'h-[40px]', "object-contain"])
      }, null, 10, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})